import { useEffect } from 'react';
import type { UIComponent } from '~/services/layout';

export const useSubscribeToActionRefreshComponent = ({
  clientFeedApiEndpoint,
  fetcherData: _fetcherData,
  fetchData,
  uiComponent,
}: {
  clientFeedApiEndpoint?: string | null;
  fetcherData?: any;
  fetchData: (forceFresh: boolean) => void;
  uiComponent: UIComponent;
}) => {
  useEffect(() => {
    const listener = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (!detail) return;

      const source = uiComponent?.data?.source;
      const matchesComponentId = Boolean(
        detail.componentId && detail.componentId === uiComponent?.id
      );

      const base = (s?: string | null) =>
        s ? s.split('?')[0].replace(/\/+$/, '') : '';

      const target = base(detail.feedPath);
      const decodedEndpoint = clientFeedApiEndpoint
        ? decodeURIComponent(clientFeedApiEndpoint)
        : '';

      const matchesFeed = Boolean(
        target &&
          (base(source) === target ||
            (decodedEndpoint &&
              (decodedEndpoint.includes(`${target}?`) ||
                decodedEndpoint.includes(`${target}&`) ||
                decodedEndpoint.includes(`${target}"`) ||
                decodedEndpoint.endsWith(target))))
      );

      if (matchesComponentId || matchesFeed) {
        fetchData(true);
      }
    };

    window.addEventListener('action:refreshComponent', listener);
    return () => {
      window.removeEventListener('action:refreshComponent', listener);
    };
  }, [clientFeedApiEndpoint, fetchData, uiComponent]);
};
